import { render, staticRenderFns } from "./BindsBottomBar.vue?vue&type=template&id=96efcd24&"
import script from "./BindsBottomBar.vue?vue&type=script&lang=js&"
export * from "./BindsBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./BindsBottomBar.vue?vue&type=style&index=0&id=96efcd24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports